import React from 'react'
import { Navigate } from 'react-router-dom'
import { useEquipmentPages } from '@/hooks/useEquipmentPages'
import type { EquipmentArea } from '@/lib/equipmentPages'

const SECTION_HOME: Record<EquipmentArea, string> = { kitchen: '/kitchen', foh: '/foh' }

// Store admins can hide an equipment page in Settings; a saved link or old
// bookmark then lands on the section's home instead of the hidden page.
export default function EquipmentPageGate({ area, children }: { area: EquipmentArea; children: React.ReactNode }) {
  const pages = useEquipmentPages()
  if (pages.isLoading) return null
  if (!pages[area]) return <Navigate to={SECTION_HOME[area]} replace />
  return <>{children}</>
}
